export default "__VITE_ASSET__WFAf4VBe__"